// extracted by mini-css-extract-plugin
module.exports = {"container":"_25d45facb5--container--w8SOa","container--pill":"_25d45facb5--container--pill--DwxmX"};